module.exports = __webpack_public_path__ + "img/slide1_5.382a10ea.png";